import PropTypes from 'prop-types';
import React, {Component} from 'react';

//helpers
import TextWidthMeasurer from 'utils/text-width-measurer';

//lodash
import omit from 'lodash/omit';

//styled-components
import {StyledInput} from './styles';

//constants
const safeCaretWidth = 4; // in some browsers text caret occupies space
const safeFallbackWidth = '6em';

export default class UnderlinedTextboxComponent extends Component {
  static defaultProps = {
    autoFocus: false,
    type: 'text'
  };

  static propTypes = {
    autoFocus: PropTypes.bool,
    error: PropTypes.string,
    type: PropTypes.oneOf(['password', 'search', 'text', 'url']),
    onChange: PropTypes.func,
    onInput: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string
  };

  measurer = null;
  inputElement = null;

  componentDidMount() {
    const {error} = this.props;

    this.setCustomValidity(error);

    this.measurer = new TextWidthMeasurer(this.inputElement);
    this.updateWidth();
  }

  componentDidUpdate(prevProps) {
    const {error, placeholder, value} = this.props;

    if (prevProps.error !== error) {
      this.setCustomValidity(error);
    }

    if (prevProps.placeholder !== placeholder || prevProps.value !== value) {
      this.updateWidth();
    }
  }

  componentWillUnmount() {
    this.measurer.destroy();
  }

  render() {
    const forwardedProps = omit(this.props, 'autoFocus', 'error');

    return <StyledInput {...forwardedProps} ref={this.handleInnerRef} onInput={this.handleInput} />;
  }

  calculateWidth = () => {
    const {placeholder} = this.props;

    if (this.inputElement.value) {
      const width = this.measurer.measure(this.inputElement.value) + safeCaretWidth;
      return `${width}px`;
    }

    if (placeholder) {
      const width = this.measurer.measure(placeholder) + safeCaretWidth;
      return `${width}px`;
    }

    return safeFallbackWidth;
  };

  handleInnerRef = instance => {
    const {autoFocus} = this.props;

    this.inputElement = instance;

    if (this.inputElement && autoFocus) {
      this.inputElement.focus();
    }
  };

  handleInput = event => {
    const {onInput} = this.props;

    this.updateWidth();

    if (typeof onInput === 'function') {
      onInput.call(this.inputElement, event);
    }
  };

  setCustomValidity = message => {
    if (!this.inputElement) {
      return;
    }

    if (message && message !== 'validating...') {
      this.inputElement.setCustomValidity(message);
    } else {
      this.inputElement.setCustomValidity('');
    }
  };

  /**
   * Updates width to contain the value
   */
  updateWidth = () => {
    if (!this.measurer || !this.inputElement) {
      return;
    }

    this.inputElement.style.width = this.calculateWidth();
  };
}
